<template>
  <div id="myLottie">
    <lottie v-show="item.value == 0" :options="options[0]" v-on:animCreated="handleAnimation0"/>
    <lottie v-show="item.value == 1" :options="options[0]" v-on:animCreated="handleAnimation1"/>
    <lottie v-show="item.value === 2" :options="options[1]" v-on:animCreated="handleAnimation2"/>
    <lottie v-show="item.value === 3" :options="options[2]" v-on:animCreated="handleAnimation3"/>
    <lottie v-show="item.value >= 4" :options="options[0]" v-on:animCreated="handleAnimation4"/>
  </div>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationEagles from "../assets/eagles.json";
import * as animationPats from "../assets/pats.json";

export default {
  name: "myLottie",
  components: {
    lottie: Lottie
  },
  props: {
    item: Object
  },
  // props
  data: function() {
    return {
      value: this.item.value,
      visited: false,
      options: [
        { animationData: animationPats.default },
        { animationData: animationPats.default },
        { animationData: animationEagles.default },
        { animationData: animationEagles.default }
      ],
      animationSpeed: this.valor // speed of animation
    };
  },
  mounted() {
    console.log("App mounted!");
    console.log(this.$route.params.num);
    this.index = {
      value: parseInt(this.$route.params.num),
      segment: [[286, 309], [309, 376]]
    };
  },
  watch: {
    valor: {
      handler(newVal, oldVal) {
        // watch it
        console.log(this.valor);
        console.log("Prop changed: ", newVal, " | was: ", oldVal);
      }
    },
    item: {
      handler(newV, oldV) {
        this.changeAnimation();
        console.log(this.item.value);
      }
    }
  },
  methods: {
    /**
     *  first animation
     *
     */
    handleAnimation0: function(anim0) {
      this.anim0 = anim0;
      this.anim0.addEventListener("DOMLoaded", () => {
        this.anim0.playSegments([[0, 74], [74, 138]], true);
      });
    },

    handleAnimation1: function(anim1) {
      this.anim1 = anim1;
      this.anim1.addEventListener("DOMLoaded", () => {
        this.anim1.playSegments([74, 138], true);
      });
    },

    handleAnimation2: function(anim2) {
      this.anim2 = anim2;
      this.anim2.addEventListener("DOMLoaded", () => {
        this.anim2.playSegments([[138, 147], [148, 212], [212, 276]], true);
      });
    },

    handleAnimation3: function(anim3) {
      this.anim3 = anim3;
      this.anim3.addEventListener("DOMLoaded", () => {
        this.anim3.playSegments([[138, 147], [148, 212], [212, 276]], true);
      });
    },

    handleAnimation4: function(anim4) {
      this.anim4 = anim4;
      this.anim4.addEventListener("DOMLoaded", () => {
        this.anim4.playSegments([[276, 309], [309, 376]], true);
      });
    },

    changeAnimation: function() {
      console.log("enter");
      switch (this.item.value) {
        case 0:
          break;

        case 1:
          break;

        case 2:
          if (this.visited) {
            this.anim2.playSegments(this.item.segment, true);
          }
          this.anim2.addEventListener("DOMLoaded", () => {
            console.log(this.item.segment);
            this.visited = true;
            this.anim2.playSegments(this.item.segment, true);
          });

          //this.anim2.playSegments(this.item.segment, true);
          break;

        case 3:
          if (this.visited) {
            this.anim3.playSegments(this.item.segment, true);
          }

          this.anim3.addEventListener("DOMLoaded", () => {
            console.log(this.item.segment);
            this.visited = true;
            this.anim3.playSegments(this.item.segment, true);
          });
          break;

        case 4:
          break;
      }
    }
  }
};
</script>
<style scope>
input[type="range"].mySlider {
  -webkit-appearance: none;
  width: 100%;
  margin: 9.45px 0;
}
input[type="range"].mySlider:focus {
  outline: none;
}
input[type="range"].mySlider::-webkit-slider-runnable-track {
  width: 100%;
  height: 7.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  background: rgba(0, 112, 188, 0.78);
  border-radius: 0px;
  border: 0.2px solid #010101;
}
input[type="range"].mySlider::-webkit-slider-thumb {
  box-shadow: 0.9px 0.9px 1px #000031, 0px 0px 0.9px #00004b;
  border: 1.8px solid #00001e;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #42b983;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -9.65px;
}
input[type="range"].mySlider:focus::-webkit-slider-runnable-track {
  background: rgba(0, 127, 214, 0.78);
}
input[type="range"].mySlider::-moz-range-track {
  width: 100%;
  height: 7.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
  background: rgba(0, 112, 188, 0.78);
  border-radius: 0px;
  border: 0.2px solid #010101;
}
input[type="range"].mySlider::-moz-range-thumb {
  box-shadow: 0.9px 0.9px 1px #000031, 0px 0px 0.9px #00004b;
  border: 1.8px solid #00001e;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #42b983;
  cursor: pointer;
}
input[type="range"].mySlider::-ms-track {
  width: 100%;
  height: 7.1px;
  cursor: pointer;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type="range"].mySlider::-ms-fill-lower {
  background: rgba(0, 97, 163, 0.78);
  border: 0.2px solid #010101;
  border-radius: 0px;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}
input[type="range"].mySlider::-ms-fill-upper {
  background: rgba(0, 112, 188, 0.78);
  border: 0.2px solid #010101;
  border-radius: 0px;
  box-shadow: 1px 1px 1px #000000, 0px 0px 1px #0d0d0d;
}
input[type="range"].mySlider::-ms-thumb {
  box-shadow: 0.9px 0.9px 1px #000031, 0px 0px 0.9px #00004b;
  border: 1.8px solid #00001e;
  height: 26px;
  width: 26px;
  border-radius: 15px;
  background: #42b983;
  cursor: pointer;
  height: 7.1px;
}
input[type="range"].mySlider:focus::-ms-fill-lower {
  background: rgba(0, 112, 188, 0.78);
}
input[type="range"].mySlider:focus::-ms-fill-upper {
  background: rgba(0, 127, 214, 0.78);
}

@media only screen and (max-width: 600px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: unset;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: unset;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .desktop {
    display: unset;
  }

  .mobile {
    display: none;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .desktop {
    display: unset;
  }

  .mobile {
    display: none;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .desktop {
    display: unset;
  }

  .mobile {
    display: none;
  }
}
</style>